"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfTransactionHistoryClient = void 0;
const NoMessagesFoundError_1 = require("./errors/NoMessagesFoundError");
// https://cardata.apps.emea.vwapps.io/documentation#tag/Transaction-History
class VcfTransactionHistoryClient {
    constructor(authServiceWeConnect, stage) {
        this.authServiceWeConnect = authServiceWeConnect;
        this.stage = stage;
        this.getGdcType = (isWcar) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;
        this.resourceHostId = `myvw-vcf-${stage}`;
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Transaction-History/operation/transactionHistory
    async getTransactionHistory(vin, isWcar) {
        const url = `vehicles/${vin}/transactionhistory?gdc=${this.getGdcType(isWcar)}`;
        const response = await this.authServiceWeConnect.get(this.resourceHostId, url, { 'User-Id': '__userId__' });
        if (response.status === 404) {
            throw new NoMessagesFoundError_1.NoMessagesFoundError();
        }
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Transaction-History
    async deleteTransactionHistory(vin, isWcar, transactionCategory) {
        const url = `vehicles/${vin}/transactionhistory/${transactionCategory}?gdc=${this.getGdcType(isWcar)}`;
        let response;
        try {
            response = await this.authServiceWeConnect.delete(this.resourceHostId, url, undefined, { 'User-Id': '__userId__' });
        }
        catch (e) {
            throw e;
        }
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
}
exports.VcfTransactionHistoryClient = VcfTransactionHistoryClient;
//# sourceMappingURL=VcfTransactionHistoryClient.js.map